/**
 * Preview mode — when set, the app runs against in-memory fixtures instead
 * of real Postgres / vendor APIs / Resend / Telegram.
 *
 * Reads `NEXT_PUBLIC_PREVIEW_MODE` (NOT plain `PREVIEW_MODE`) so the value
 * is inlined into the browser bundle by Next's compiler. Plain env vars
 * are server-only — if the auth-client checks the wrong name, useSession()
 * falls through to real better-auth on the client and every page kicks
 * to /sign-in even though server renders see the preview session.
 *
 * Reference must be `process.env.NEXT_PUBLIC_PREVIEW_MODE` literally — the
 * inliner does not follow indirection.
 */
export const isPreviewMode = (): boolean =>
  process.env.NEXT_PUBLIC_PREVIEW_MODE === "true";
